export type PracticeAttempt = {
  id: number;
  promptId: string;
  draft: string;
  revision: string | null;
  assistanceMode: string;
  signals: string;
  status: string;
  updatedAt: string;
};

function practiceAttemptContentKey(attempt: PracticeAttempt): string {
  return JSON.stringify([
    attempt.promptId,
    attempt.draft.trim(),
    attempt.revision?.trim() || "",
    attempt.assistanceMode,
    attempt.signals,
    attempt.status,
  ]);
}

/**
 * Keep the most recent copy of an exact saved expression. Retries and repeated
 * local QA runs must not turn one deliberate wording into several visible
 * learning claims. Different studies, revisions, stances, or statuses remain
 * distinct.
 */
export function dedupePracticeAttempts(attempts: PracticeAttempt[]): PracticeAttempt[] {
  const newestFirst = [...attempts].sort((left, right) => {
    const timeDifference = Date.parse(right.updatedAt) - Date.parse(left.updatedAt);
    return Number.isNaN(timeDifference) || timeDifference === 0
      ? right.id - left.id
      : timeDifference;
  });
  const seen = new Set<string>();
  return newestFirst.filter((attempt) => {
    const key = practiceAttemptContentKey(attempt);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}
